<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="综合查询">
          <el-input placeholder="请输入企业名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        
        <el-form-item label="所属行业">
          <el-select v-model="formInline.industry" placeholder="请选择行业" clearable style="width: 150px;">
            <el-option v-for="item in industryList" :key="item.ma_training_industry_id" :label="item.name" :value="item.ma_training_industry_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="培训类型">
          <el-select v-model="formInline.training_category" placeholder="请选择培训类型" clearable style="width: 150px;">
            <el-option v-for="item in trainingCategoryList" :key="item.ma_training_category_id" :label="item.name" :value="item.ma_training_category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加企业</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="name" label="企业名称"></el-table-column>
            <el-table-column prop="administrator_name" label="默认管理员" width="120"></el-table-column>
            <el-table-column prop="organization_name" label="组织名称" width="150"></el-table-column>
            <el-table-column prop="organization_type" label="组织类型" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.organization_type || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="region_name" label="行政区域" width="200">
              <template slot-scope="scope">
                <span>{{ scope.row.province_name }} {{ scope.row.city_name }} {{ scope.row.region_name }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="industry_name" label="所属行业" width="120"></el-table-column> -->
            <!-- <el-table-column prop="training_category_name" label="培训类型" width="120"></el-table-column>
            <el-table-column prop="sort" label="排序" width="80"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column> -->
            <el-table-column fixed="right" label="操作" width="280">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small">详情</el-button>
                <el-button @click="adminSettingClick(scope.row)" type="text" size="small">管理员设置</el-button>
                <el-button @click="roleManageClick(scope.row)" type="text" size="small">角色管理</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :ma_company_id="ma_company_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Detail :open_add="open_detail" :ma_company_id="ma_company_id" v-if="open_detail"   @close="closeDetail"></Detail>
    <AdminSetting :open_add="open_adminSetting" :ma_company_id="ma_company_id_for_adminSetting" v-if="open_adminSetting" @close="closeAdminSetting"></AdminSetting>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import Ma_companyApi from '@/api/ma_company.js';
  import Ma_organizationApi from '@/api/ma_organization.js';
  import OrganizationTypeApi from '@/api/organization_type.js';
  import Ma_training_industryApi from '@/api/ma_training_industry.js';
  import Ma_training_categoryApi from '@/api/ma_training_category.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Detail from './part/detail.vue';
  import AdminSetting from './part/adminSetting.vue';

  export default {
    components: {
      Add,
      Edit,
      Detail,
      AdminSetting,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          organization:"",
          organization_type:"",
          industry:"",
          training_category:""
        },

        open_add:false,
        open_edit:false,
        open_detail:false,
        open_adminSetting:false,
        ma_company_id:"",
        ma_company_id_for_adminSetting:"",
        dialogVisible:false,
        organizationList:[],
        organizationTypeList:[],
        industryList:[],
        trainingCategoryList:[],
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
      this.getOrganizationList();
      this.getOrganizationTypeList();
      this.getIndustryList();
      this.getTrainingCategoryList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//企业标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
      /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      closeDetail(e){
        this.open_detail=false;
      },
      closeAdminSetting(e){
        this.open_adminSetting=false;
      },
      getData(){
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Ma_companyApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*获取组织列表*/
      getOrganizationList() {
        let self = this;
        Ma_organizationApi.list({}, true).then(res => {
          if (res.data && res.data.list && Array.isArray(res.data.list.data)) {
            self.organizationList = res.data.list.data;
          } else if (res.data && Array.isArray(res.data.list)) {
            self.organizationList = res.data.list;
          } else if (res.data && Array.isArray(res.data)) {
            self.organizationList = res.data;
          } else {
            self.organizationList = [];
          }
        }).catch(error => {
          self.organizationList = [];
        });
      },

      /*获取组织类型列表*/
      getOrganizationTypeList() {
        let self = this;
        OrganizationTypeApi.list({}, true).then(res => {
          if (res.data && res.data.list && Array.isArray(res.data.list.data)) {
            self.organizationTypeList = res.data.list.data;
          } else if (res.data && Array.isArray(res.data.list)) {
            self.organizationTypeList = res.data.list;
          } else if (res.data && Array.isArray(res.data)) {
            self.organizationTypeList = res.data;
          } else {
            self.organizationTypeList = [];
          }
        }).catch(error => {
          self.organizationTypeList = [];
        });
      },

      /*获取行业列表*/
      getIndustryList() {
        let self = this;
        Ma_training_industryApi.list({}, true).then(res => {
          if (res.data && res.data.list && Array.isArray(res.data.list.data)) {
            self.industryList = res.data.list.data;
          } else if (res.data && Array.isArray(res.data.list)) {
            self.industryList = res.data.list;
          } else if (res.data && Array.isArray(res.data)) {
            self.industryList = res.data;
          } else {
            self.industryList = [];
          }
        }).catch(error => {
          self.industryList = [];
        });
      },

      /*获取培训类别列表*/
      getTrainingCategoryList() {
        let self = this;
        Ma_training_categoryApi.list({}, true).then(res => {
          if (res.data && res.data.list && Array.isArray(res.data.list.data)) {
            self.trainingCategoryList = res.data.list.data;
          } else if (res.data && Array.isArray(res.data.list)) {
            self.trainingCategoryList = res.data.list;
          } else if (res.data && Array.isArray(res.data)) {
            self.trainingCategoryList = res.data;
          } else {
            self.trainingCategoryList = [];
          }
        }).catch(error => {
          self.trainingCategoryList = [];
        });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.ma_company_id = row.ma_company_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Ma_companyApi.del(
              {
                ma_company_id: row.ma_company_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },

      /*查看详情*/
      detailClick(row) {
        console.log('detailClick called');
        console.log('row:', row);
        console.log('row.ma_company_id:', row.ma_company_id);
        console.log('typeof row.ma_company_id:', typeof row.ma_company_id);
        this.ma_company_id = row.ma_company_id;
        this.open_detail = true;
        console.log('After assignment - ma_company_id:', this.ma_company_id, 'open_detail:', this.open_detail);
      },

      /*管理员设置*/
      adminSettingClick(row) {
        this.ma_company_id_for_adminSetting = row.ma_company_id;
        this.open_adminSetting = true;
      },

      /*角色管理*/
      roleManageClick(row) {
        this.$router.push({
          path: '/auth/role/index',
          query: {
            ma_company_id: row.ma_company_id
          }
        });
      }
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/ma_company/index/index.vue